import { notification } from 'antd';
import { AppContext } from 'App.context';
import { useContext, useEffect, useState } from 'react';
import constants from 'utils/constants';
import { ApiContext } from 'utils/networking/Api.context';

export default function useInvoiceS3ConfigHook() {
  const {
    appState,
    appActions: { getSelectedHotel, translate },
  } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    isModalOpen: false,
    isLoading: false,
    fileFormat: null,
    filePrefix: null,
    fileSufix: null,
    s3DirPath: null,
    testFile: null,
    ftpFiles: [],
    ftpErrors: [],
    ftpResult: [],
    ftpfileValidationError: null,
    fileContent: null,
    isValidation: false,
    isFileList: false,
    dateSelected: null,
    extension: null,
    sendStatusType: null,
    sshKey: '',
    authMethod: 'ssh',
    s3Pass: null,
    ips: [''],
    s3UserName: null,
    removedIps: [],
    sourcePms: null,
  });

  const isValidIp = ip => {
    return /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/.test(ip);
  };

  const validatePasswordS3 = password => {
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasDigits = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?:{}|\-_=+;]/.test(password);

    const hasForbiddenChars = /["`'<>\[\]]/.test(password);

    if (
      password.length < 12 ||
      password.length > 20 ||
      !(hasUpperCase && hasLowerCase && hasDigits && hasSpecialChar) ||
      hasForbiddenChars
    )
      return false;

    return true;
  };

  const randomNum = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  useEffect(() => {
    const fetchConfig = async () => {
      const s3Pass = await actions.loadInvoiceS3Config();
      await actions.loadS3Users(s3Pass);
    };
    fetchConfig();
  }, [appState.selectedHotel]);

  const actions = {
    generatePassword: () => {
      const lowers = 'abcdefghijklmnopqrstuvwxyz';
      const uppers = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const numbers = '0123456789';
      const specials = '!@#$%^&*(),.?:{}|-_=+;';

      const allChars = lowers + uppers + numbers + specials;
      const maxLong = randomNum(12, 20);

      let pass = '';
      let numExist = false;
      let lowersExist = false;
      let uppersExist = false;
      let specialsExist = false;

      while (pass.length < maxLong || !numExist) {
        if (pass.length == maxLong - 1 && !specialsExist) {
          pass += specials.charAt(Math.floor(randomNum(0, specials.length)));
        } else if (pass.length == maxLong - 2 && !uppersExist) {
          pass += uppers.charAt(Math.floor(randomNum(0, uppers.length)));
        } else if (pass.length == maxLong - 3 && !numExist) {
          pass += randomNum(0, 9).toString();
        } else if (pass.length == maxLong - 4 && !lowersExist) {
          pass += lowers.charAt(Math.floor(randomNum(0, lowers.length)));
        } else {
          pass += allChars.charAt(Math.floor(randomNum(0, allChars.length)));
        }

        //Validate password
        if (!numExist) numExist = /\d/.test(pass);
        if (!lowersExist) lowersExist = /[a-z]/.test(pass);
        if (!uppersExist) uppersExist = /[A-Z]/.test(pass);
        if (!specialsExist) specialsExist = /[!@#$%^&*(),.?":{}|\-_=+;]/.test(pass);
      }

      return pass;
    },

    loadInvoiceS3Config: async () => {
      try {
        updateState({ isLoading: true });

        const res = await API.getInvoiceSFTP(getSelectedHotel()?.key);

        const invoiceConfig = res?.sftpCredentials || {};

        const file = invoiceConfig?.fileFormat || '';
        const extension = file ? file.substring(file.lastIndexOf('.')) : '.xml';
        const fileWithoutExtension = file
          ? file.substring(0, file.lastIndexOf(extension))
          : 'YYYY-MM-DD';
        const filePrefix = invoiceConfig?.filePrefix || '';
        const fileSufix = invoiceConfig?.fileSufix || '';
        const sourcePms = invoiceConfig?.sourcePms || 'Opera';
        let s3Pass = null,
          authMethod = sourcePms === 'Opera' ? 'password' : 'ssh';
        if (invoiceConfig?.password) {
          s3Pass = invoiceConfig.password;
          authMethod = 'password';
        }

        updateState({
          isLoading: false,
          fileFormat: fileWithoutExtension,
          extension,
          filePrefix,
          fileSufix,
          sourcePms,
          s3Pass,
          authMethod,
        });
        return s3Pass;
      } catch (err) {
        console.warn(err);
        updateState({ isLoading: false });
      }
    },

    loadS3Users: async s3Pass => {
      let sshKey = null;
      try {
        updateState({ isLoading: true });

        const res = await API.getS3Users(getSelectedHotel()?.key);

        sshKey =
          res?.ssh_public_key && Object.keys(res.ssh_public_key).length > 0
            ? res.ssh_public_key
            : '';

        if (!s3Pass && !sshKey) {
          s3Pass = await actions.generatePassword();
        }

        const ips = Array.isArray(res?.ip_address) ? res.ip_address.filter(isValidIp) : [''];

        updateState({
          isLoading: false,
          sshKey,
          s3Pass,
          ips: ips && ips.length > 0 ? ips : [''],
          s3UserName: res?.hotelUser || getSelectedHotel()?.key + '-invoices',
        });
      } catch (err) {
        if (!s3Pass && !sshKey) {
          s3Pass = await actions.generatePassword();
        }
        updateState({
          isLoading: false,
          s3UserName: getSelectedHotel()?.key + '-invoices',
          s3Pass,
        });
      }
    },

    onSaveS3Config: async () => {
      try {
        updateState({ isLoading: true });

        const ips = state?.ips || [];

        const invalidIps = ips.filter(ip => !isValidIp(ip));

        let validatePassword = true;
        if (state.authMethod === 'password') validatePassword = validatePasswordS3(state.s3Pass);

        if (invalidIps.length > 0 || !validatePassword) {
          updateState({ isLoading: false });

          setState(prev => ({
            ...prev,
            invalidIps: invalidIps.length > 0 ? invalidIps : null,
            invalidPass: !validatePassword && state.authMethod === 'password',
          }));
          if (invalidIps.length > 0)
            notification.error({ message: translate('hbxProducts.someIpAddressInvalid') });
          if (!validatePassword && state.authMethod === 'password')
            notification.error({ message: translate('hbxProducts.somePasswordAddressInvalid') });
          return;
        }

        const hotelData = await API.getOneHotel({ hotelId: getSelectedHotel()?.key });

        await API.saveInvoiceSFTP(getSelectedHotel()?.key, hotelData.atlasId, 'active', {
          provider: constants.BOOKING_PROVIDER.S3,
          fileFormat: state.fileFormat + state.extension,
          filePrefix: state.filePrefix,
          fileSufix: state.fileSufix,
          sourcePms: state.sourcePms,
        });

        notification.success({
          message: translate('policeReport.saveConfigSuccess'),
        });

        await actions.saveS3Users(hotelData);
        await actions.deleteS3Users(hotelData, state.removedIps || []);

        updateState({ isLoading: false });
      } catch (err) {
        updateState({ isLoading: false });
        notification.error({ message: translate('policeReport.ftpError') });
      }
    },

    saveS3Users: async hotel => {
      try {
        const joinedIps = state?.ips?.join(',').trim();

        const usarData = await API.userRequest({ userId: appState.userId });

        const sshKey = state.authMethod === 'ssh' ? state.sshKey : '';
        const s3Pass = state.authMethod === 'password' ? state.s3Pass : null;

        updateState({ sshKey, s3Pass });

        await API.saveS3Users({
          hotelId: hotel.id,
          chainId: hotel.chainId,
          sshKey: sshKey,
          password: s3Pass,
          email: usarData.email,
          name: usarData.name,
          lang: appState.currentLanguage.id,
          ips: joinedIps,
        });

        notification.success({
          message: translate('hbxProducts.successS3Users'),
        });
      } catch (err) {
        notification.error({ message: translate('hbxProducts.errorS3Users') });
        if (err?.response?.data?.invalidIps) {
          const invalidIps = err.response.data.invalidIps;
          setState(prev => ({
            ...prev,
            invalidIps,
          }));
          notification.error({ message: translate('hbxProducts.someIpAddressInvalid') });
        }
        if (err?.response?.data?.validatePassword) {
          const invalidPass = err.response.data.validatePassword;
          setState(prev => ({
            ...prev,
            invalidPass,
          }));
          notification.error({ message: translate('hbxProducts.somePasswordAddressInvalid') });
        }
      }
    },

    deleteS3Users: async (hotel, ipsToRemove) => {
      try {
        const ipsReallyToRemove = [...new Set(ipsToRemove.filter(ip => !state?.ips?.includes(ip)))];

        if (ipsReallyToRemove.length === 0) return;

        await API.deleteS3Users(hotel.id, ipsReallyToRemove.join(',').trim());
      } catch (err) {
        console.warn('Error deleting S3 users IPs:' + err);
      }
    },

    onCheckConnection: async () => {
      {
        try {
          const joinedIpsState = state?.ips?.join(',').trim();

          const res = await API.getInvoiceSFTP(getSelectedHotel()?.key);
          const invoiceConfig = res?.sftpCredentials || {};

          const s3Users = await API.getS3Users(getSelectedHotel()?.key);

          if (s3Users) {
            notification.success({
              message: translate('hbxProducts.successS3Check'),
            });

            const ips = Array.isArray(s3Users?.ip_address)
              ? s3Users.ip_address.filter(isValidIp)
              : [''];
            const joinedIpsUsers = ips?.join(',').trim();
            const sshKey =
              s3Users?.ssh_public_key && Object.keys(s3Users.ssh_public_key).length > 0
                ? s3Users.ssh_public_key
                : '';

            const failedFields = [];

            if (state.s3Pass && invoiceConfig.password !== state.s3Pass) {
              failedFields.push('Password');
            }
            if (state.sshKey && sshKey !== state.sshKey) {
              failedFields.push('SSH Key');
            }
            if (joinedIpsState !== joinedIpsUsers) {
              failedFields.push('IPs');
            }

            if (failedFields.length > 0) {
              notification.error({
                message: `${translate('hbxProducts.failedS3Users')}: ${failedFields.join(', ')}`,
              });
            }
          } else {
            notification.error({ message: translate('hbxProducts.notS3UsersConfig') });
          }
        } catch (err) {
          notification.error({ message: translate('hbxProducts.errorCheckS3Users') });
        }
      }
    },

    setField: (fieldKey, value) => updateState({ [fieldKey]: value }),

    isAdmin: () => !!appState?.superUser,
  };

  function updateState(obj) {
    setState(prev => ({ ...prev, ...obj }));
  }

  return { state, actions };
}
